import * as React from 'react';
import { DateTimeInput } from '../../../components/form-elements/DateTimeInput';
import { LocalTimeRead } from '../../../models/utilities/local-time-read';
import { GlobalConstants } from '../../../utils/app-constants';
import { StartShipmentAction } from '../../models/shipments/shipment-action';

interface IProps {
    origin : StartShipmentAction;    
    isQuickCreate: boolean;
    updateTruck: any;
}

export const ShipmentEditOrigin = (props : IProps) => {

    const [editOrigin, setEditOrigin] = React.useState<StartShipmentAction>(new StartShipmentAction());
    
    /**
     * Hydrate the required properties for editing
     */
    React.useEffect(() => {
        if (props.origin) {
            setEditOrigin({...props.origin});
        }
    }, [props.origin]);

    /**
     * Handler for changing the shipment date.
     * @param newDate The new shipment date as chosen 
     */
    const onCutoffDateChange = (newDate: Date) => {         
        const t = {...editOrigin};

        if (!t.actionTime) {
            t.actionTime = new LocalTimeRead();
        }

        t.actionTime.local = newDate;
        setEditOrigin(t);

        if (props.isQuickCreate) {
            props.updateTruck(t, props.origin.tmpClientId);
        }
    };

    return <div className="stop-action-edit-delivery">
                                      
                <div className="row">
                    <div className="col-md-6">
                        <DateTimeInput
                            id="pickupTime"
                            format={ GlobalConstants.ABBR_LONG_DATE }
                            value={ editOrigin.actionTime ? editOrigin.actionTime.local : undefined }
                            showTimezone={ true }
                            timezone={ editOrigin.address.timeZoneId }
                            label="Departure Time"
                            onChange={ onCutoffDateChange }
                        />
                    </div>
                </div>
                          
    </div>;

};
